import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import ClaimsContext from '../ClaimsContext';

export interface ClaimsProviderProps {
  children: ReactNode;
  hasClaim: (claim: string, value?: string) => Promise<boolean>;
  termsOfUseClaim: string;
  dcaClaim: string;
}

const ClaimsProvider: FC<ClaimsProviderProps> = ({ children, hasClaim, termsOfUseClaim, dcaClaim }) => {
  const [isDCA, setIsDCA] = useState(false);
  const [isTermsOfUseConsents, setIsTermsOfUseConsents] = useState(true);
  const context = useMemo(() => ({ isDCA, isTermsOfUseConsents }), [isDCA, isTermsOfUseConsents]);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    hasClaim(dcaClaim).then((x) => setIsDCA(x));
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    hasClaim(termsOfUseClaim, 'false').then((x) => setIsTermsOfUseConsents(!x));
  }, [hasClaim, dcaClaim, termsOfUseClaim]);

  return (
    <ClaimsContext.Provider value={context}>
      {children}
    </ClaimsContext.Provider>
  );
};

export default ClaimsProvider;
